// 渲染红包
import React, {memo} from 'react'

const RenderRedPackageMsg = memo((props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  const imgMaxWidth = document.body.clientWidth * 0.4
  let emotionWidth = message?.emotionWidth || 0
  let emotionHeight = message?.emotionHeight || 0
  let scale = 1
  if(emotionWidth > imgMaxWidth) {
    scale = emotionWidth / imgMaxWidth
  }
  return (
    <div>
      <img style={{width:emotionWidth / scale,height:emotionHeight / scale}} src={message?.url} alt="表情符号" />
    </div>
  )
})

export default RenderRedPackageMsg